import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findGearSpecList, changeGearSpecActivePage, deleteGearSpec, openGearSpecModal, findGearSpec
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['gearSpecListReducer', 'gearSpecList']),
	activePage: state.getIn(['gearSpecListReducer', 'activePage']),
	itemPerPage: state.getIn(['gearSpecListReducer', 'itemPerPage']),
	totalPage: state.getIn(['gearSpecListReducer', 'totalPage']),
	searchWord: state.getIn(['gearSpecListReducer', 'searchWord']),
	pagingMaxButtons: 5,
	fields: {
		spec_id: 'ID',
		spec_name: '規格名稱',
		gear_alias_name: '產品名稱',
		model_display_name: '型號顯示名稱'
	},
	keys: ['spec_id'],
	searchKeys: ['spec_name', 'model_display_name'],
	showCheckBox: true
})

const mapDispatchToProps = (dispatch) => ({
	refresh: (pagingData) => {
		dispatch(findGearSpecList(pagingData));
	},
	changeActivepage: (pagingData, searchData) => {
		dispatch(changeGearSpecActivePage(pagingData));
		dispatch(findGearSpecList(pagingData, searchData));
	},
	deleteItems: (deleteKey, pagingData) => {
		dispatch(deleteGearSpec(deleteKey, pagingData));
	},
	openAddModal: () => {
		dispatch(openGearSpecModal({ forInsert: true }));
	},
	handleEdit: (pk) => {
		dispatch(findGearSpec(pk));
		dispatch(openGearSpecModal({ forInsert: false }));
	},
	search: (pagingData, searchData) => {
		dispatch(findGearSpecList(pagingData, searchData));
	}
})

const GearSpecListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default GearSpecListContainer;


// WEBPACK FOOTER //
// ./src/containers/GearSpecListContainer.jsx